﻿$.fn.dxCtrlEmailMiseEnPage = function custom_dxCtrlEmailMiseEnPage(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlemailmiseenpage dx-ctrl");
        this.createInstance(new cdxCtrlEmailMiseEnPage(this, option));
    }
    return this;
}

window.cdxCtrlEmailMiseEnPage = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivArrierePlan = null;
    function mConstruit() {
        container.empty()
        var $DivEntete = $("<div/>").appendTo(container)
        var $Table = $("<table style='width:100%;font-size:140%;table-layout:fixed;'/>").appendTo($DivEntete)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:24px;padding-right:5px;color:" + theme.backgroundcolorAccent + ";'><i class='fas fa-swatchbook'></i></td>").appendTo($Tr)
        var $Td = $("<td style='width:100%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;'>Mise en page email</td>").appendTo($Tr)
        var $Td = $("<td style='width:52px;'></td>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: 'fas fa-times',
            width: 26,
            height: 26,
            onClick: function (e) {
                option.onClose()
            }
        })

        resizeObserver.mAdd($DivEntete, function () { dxScroll.element().css("height", "calc(100% - " + $DivEntete.innerHeight() + "px)") })


        var dxScroll = $("<div style='width:100%;height:calc(100% - " + $DivEntete.innerHeight() + "px);'/>").appendTo(container).dxScrollView({}).dxScrollView("instance")

        var paddingTop = option.elementArrierePlan.css("padding-top").replace("px", "")
        var paddingLeft = option.elementArrierePlan.css("padding-left").replace("px", "")
        var paddingRight = option.elementArrierePlan.css("padding-right").replace("px", "")
        var paddingBottom = option.elementArrierePlan.css("padding-bottom").replace("px", "")
        var fontSize = option.body.css("font-size")
        var fontColor = option.body.css("color")
        var fontFamily = option.body.css("font-family").remplacerTout('"', '')
        var interligne = (option.body.css("line-height").replace("px", "") / fontSize.replace("px", "")).toString()
        var lstFont = []

        option.body.css("text-align", "left")

        option.fontFamilyFormat.split(";").forEach(function (fontFamily) {
            lstFont.push({
                name: fontFamily.split("=")[0].trim(),
                fontfamily: fontFamily.split("=")[1].trim()
            })
        })
        var lstSize = option.fontSizeFormats.split(" ")
        var lstInterligne = option.lineHeightFormat.split(" ")
        dxScroll.content().css("padding", "5px 15px 5px 15px")


        if (option.isAssistant) {
            var maxWidth = option.elementArrierePlan.css("max-width").replace("px", "")
            $("<div style='font-size:140%;color:" + theme.backgroundcolorAccent + ";'>Largeur maximale de votre message</div>").appendTo(dxScroll.content())
            $("<div style='width:100%'/>").appendTo(dxScroll.content()).dxCtrlNumberBox({
                labelMode: 'floating',
                label: "Largeur max en pixel",
                value: maxWidth,
                width: "100%",
                onValueChanged: function (e) {
                    if (e.value == null || e.value == 0) { e.component.option("value", "600px") }
                    else { option.elementArrierePlan.css("max-width", e.value + "px") }
                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                }
            })
        }

        $("<div style='font-size:140%;color:" + theme.backgroundcolorAccent + ";'>Police</div>").appendTo(dxScroll.content())
        $("<div/>").appendTo(dxScroll.content()).dxSelectBox({
            labelMode: 'floating',
            label: "Police",
            dataSource: lstFont,
            displayExpr: "name",
            valueExpr: "fontfamily",
            value: fontFamily,
            itemTemplate: function (itemData, itemIndex, itemElement) {
                itemElement.css("font-family", itemData.fontfamily)
                itemElement.text(itemData.name)
            },
            onValueChanged: function (e) {
                option.body.css("font-family", e.value)
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            }
        })
        $("<br/>").appendTo(dxScroll.content())

        $("<div  style='margin:5px 0;'/>").appendTo(dxScroll.content()).dxCtrlColorPicker({
            value: fontColor,
            title: "Couleur des polices",
            titlePaletteSelect: "",
            onValueChanged: function (e) {
                option.body.css("color", e.value)
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            }
        }).dxCtrlColorPicker("instance")

        //$("<div/>").appendTo(dxScroll.content()).dxColorBox({
        //    labelMode: 'floating',
        //    label: "Couleur police",
        //    openOnFieldClick: true,
        //    value: fontColor,
        //    editAlphaChannel: true,
        //    onValueChanged: function (e) {
        //        option.body.css("color", e.value)
        //        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //    }
        //});
        $("<br/>").appendTo(dxScroll.content())

        var $Table = $("<table style='white-space:nowrap;display:inline-block;'/>").appendTo(dxScroll.content());
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:50%;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxSelectBox({
            labelMode: 'floating',
            label: "Taille police",
            dataSource: lstSize,
            value: fontSize,
            onValueChanged: function (e) {
                option.body.css("font-size", e.value)
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            }
        })
        var $Td = $("<td style='padding-left:10px;width:50%;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxSelectBox({
            labelMode: 'floating',
            label: "Interligne",
            dataSource: lstInterligne,
            value: interligne,
            onValueChanged: function (e) {
                option.body.css("line-height", e.value)
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            }
        })

        $("<br/>").appendTo(dxScroll.content())
        $("<br/>").appendTo(dxScroll.content())
        $("<div style='font-size:140%;color:" + theme.backgroundcolorAccent + ";'>Marge (en px)</div>").appendTo(dxScroll.content())
        //var $DivMarge = $("<div style='border:" + theme.border + ";border-radius:5px;padding:10px;margin-top:15px;'><span style='font-size:20px;'>Marge (mm)</span></div>").appendTo(dxScroll.content())
        //var $Table = $("<table style='width:100%;'/>").appendTo($DivMarge);
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $Td = $("<td style='padding:10px;text-align:right;'></td>").appendTo($Tr)
        $("<div style='width:100%'/>").appendTo(dxScroll.content()).dxCtrlNumberBox({
            labelMode: 'floating',
            label: "Marge haut",
            value: paddingTop,
            width: "100%",
            onValueChanged: function (e) {
                option.elementArrierePlan.css("padding-top", e.value + "px")
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            }
        })
        $("<br/>").appendTo(dxScroll.content())
        //var $Td = $("<td style='padding:10px;text-align:right;'></td>").appendTo($Tr)
        $("<div style='width:100%'/>").appendTo(dxScroll.content()).dxCtrlNumberBox({
            labelMode: 'floating',
            label: "Marge bas",
            value: paddingBottom,
            width: "100%",
            onValueChanged: function (e) {
                option.elementArrierePlan.css("padding-bottom", e.value + "px")
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            }
        })
        $("<br/>").appendTo(dxScroll.content())
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $Td = $("<td style='padding:10px;text-align:right;'></td>").appendTo($Tr)
        $("<div style='width:100%'/>").appendTo(dxScroll.content()).dxCtrlNumberBox({
            labelMode: 'floating',
            label: "Marge gauche",
            value: paddingLeft,
            width: "100%",
            onValueChanged: function (e) {
                option.elementArrierePlan.css("padding-left", e.value + "px")
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            }
        })
        $("<br/>").appendTo(dxScroll.content())
        //var $Td = $("<td style='padding:10px;text-align:right;'></td>").appendTo($Tr)
        $("<div style='width:100%'/>").appendTo(dxScroll.content()).dxCtrlNumberBox({
            labelMode: 'floating',
            label: "Marge droite",
            value: paddingRight,
            width: "100%",
            onValueChanged: function (e) {
                option.elementArrierePlan.css("padding-right", e.value + "px")
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            }
        })
        $("<br/>").appendTo(dxScroll.content())

        var backgroundColor = option.elementArrierePlan.css("background-color")

        $("<br/>").appendTo(dxScroll.content())
        //$("<div style='font-size:140%;color:" + theme.backgroundcolorAccent + ";'>Arrière plan</div>").appendTo(dxScroll.content())
        $("<div  style='margin:5px 0;'/>").appendTo(dxScroll.content()).dxCtrlColorPicker({
            value: backgroundColor,
            title: "Couleur arrière plan",
            titlePaletteSelect: "",
            onValueChanged: function (e) {
                option.body.css("background-color", e.value)
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            }
        }).dxCtrlColorPicker("instance")
        //$("<div/>").appendTo(dxScroll.content()).dxColorBox({
        //    labelMode: 'floating',
        //    label: "Couleur arrière plan",
        //    openOnFieldClick: true,
        //    value: backgroundColor,
        //    editAlphaChannel: true,
        //    onValueChanged: function (e) {
        //        option.body.css("background-color", e.value);
        //        if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
        //    }
        //});
        $("<br/>").appendTo(dxScroll.content())

        $DivArrierePlan = $("<div/>").appendTo(dxScroll.content())
        mRempliArrierePlan()

    }

    function mRempliArrierePlan() {
        $DivArrierePlan.empty()

        var backgroundImage = option.elementArrierePlan.css("background-image")
        if (typeof backgroundImage != 'undefined' && backgroundImage.length > 0 && backgroundImage != "none") {
            try {
                backgroundImage = backgroundImage.split("url(")[1]
                backgroundImage = backgroundImage.split(")")[0]
                if (backgroundImage.startsWith("'") || backgroundImage.startsWith('"')) {
                    backgroundImage = backgroundImage.substring(1)
                    backgroundImage = backgroundImage.substring(0, backgroundImage.length - 1)
                }
            } catch (e) {
                backgroundImage = "fakeurl.png"
            }


            var $Table = $("<table style='width:100%;'/>").appendTo($DivArrierePlan)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
            $("<img src='" + backgroundImage + "' style='width:100%;'/>").appendTo($Td)
            var $Td = $("<td style='width:1px;vertical-align:middle'/>").appendTo($Tr)
            $("<div/>").appendTo($Td).dxCtrlButton({
                icon: 'fas fa-delete-left',
                width: HeightButton,
                height: HeightButton,
                onClick: function (e) {
                    option.elementArrierePlan.css("background-image", "")
                    mRempliArrierePlan()
                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                }
            })

            $("<div style='font-size:120%;color:" + theme.backgroundcolorAccent + ";'>Répétition</div>").appendTo($DivArrierePlan)
            var backgroundRepeat = option.elementArrierePlan.css("background-repeat")
            var dsRepeat = [{ value: "repeat", detail: "L'image d'arrière-plan est répétée verticalement et horizontalement. La dernière image sera tronquée si elle ne rentre pas." },
            { value: "repeat-x", detail: "L'image d'arrière-plan est répétée uniquement horizontalement." },
            { value: "repeat-y", detail: "L'image d'arrière - plan est répétée uniquement verticalement." },
            { value: "no-repeat", detail: "L'image d'arrière-plan n'est pas répétée. L'image ne sera affichée qu'une seule fois." },
            { value: "space", detail: "L'image d'arrière-plan est répétée autant que possible sans écrêtage. La première et la dernière image sont épinglées de chaque côté de l'élément et les espaces sont répartis uniformément entre les images." },
            { value: "round", detail: "L'image d'arrière-plan est répétée et écrasée ou étirée pour remplir l'espace (pas de vide)." },
            { value: "initial", detail: "" },
            { value: "inherit", detail: "" }]
            $("<div style='padding-left:20px;'/>").appendTo($DivArrierePlan).dxCtrlRadioGroup({
                dataSource: dsRepeat,
                focusStateEnabled: false,
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    $("<div>" + itemData.value + "</div>").appendTo(itemElement)
                    $("<div style='font-size:70%;opacity:0.6;line-height:1.2;'>" + itemData.detail + "</div>").appendTo(itemElement)
                },
                value: dsRepeat.filter(function (o) { return o.value == backgroundRepeat })[0],
                layout: 'vertical',
                onValueChanged: function (e) {
                    backgroundRepeat = e.value.value
                    option.elementArrierePlan.css("background-repeat", backgroundRepeat)
                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                }
            })

            $("<div style='font-size:120%;color:" + theme.backgroundcolorAccent + ";'>Taille</div>").appendTo($DivArrierePlan)
            var backgroundSize = option.elementArrierePlan.css("background-size")
            if (backgroundSize.length == 0) backgroundSize = "cover"
            var dsTaille = [{ value: "cover", detail: "Redimensionnez l'image d'arrière-plan pour couvrir tout le conteneur, même si vous devez étirer l'image ou couper un peu l'un des bords." },
            { value: "contain", detail: "Redimensionnez l'image d'arrière - plan pour vous assurer qu'elle est entièrement visible." },
            { value: "auto", detail: "L'image d'arrière-plan s'affiche dans sa taille d'origine." },
            { value: "initial", detail: "" },
            { value: "inherit", detail: "" },
            { value: "personnalisé", detail: "" }]
            var selectedTaille = dsTaille.filter(function (o) { return o.value == backgroundSize })[0]
            if (typeof selectedTaille == 'undefined') selectedTaille = dsTaille.filter(function (o) { return o.value == "personnalisé" })[0]
            $("<div style='padding-left:20px;'/>").appendTo($DivArrierePlan).dxCtrlRadioGroup({
                dataSource: dsTaille,
                focusStateEnabled: false,
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    $("<div>" + itemData.value + "</div>").appendTo(itemElement)
                    $("<div style='font-size:70%;opacity:0.6;line-height:1.2;'>" + itemData.detail + "</div>").appendTo(itemElement)
                },
                value: selectedTaille,
                layout: 'vertical',
                onValueChanged: function (e) {
                    if (e.value.value == "personnalisé") {
                        $DivSaisieSize.slideDown(100)
                        backgroundSize = dxTxtTaille.option("value")
                        option.elementArrierePlan.css("background-size", dxTxtTaille.option("value"))
                    } else {
                        $DivSaisieSize.slideUp(100)
                        backgroundSize = e.value.value
                        option.elementArrierePlan.css("background-size", backgroundSize)
                    }
                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                }
            })
            var $DivSaisieSize = $("<div style='padding-left:20px;" + ((selectedTaille.value == "personnalisé") ? "" : "display:none;") + "'/>").appendTo($DivArrierePlan)
            var dxTxtTaille = $("<div/>").appendTo($DivSaisieSize).dxCtrlTextBox({
                value: ((typeof selectedTaille == 'undefined') ? backgroundSize : ""),
                onValueChanged: function (e) {
                    backgroundSize = e.value
                    option.elementArrierePlan.css("background-size", backgroundSize)
                }
            }).dxCtrlTextBox("instance")
            $("<div style='font-size:70%;font-style:italic;opacity:0.3;'>(ex: 30px 25px): Définit la largeur et la hauteur de l'image d'arrière-plan en pixel. La première valeur définit la largeur, la deuxième valeur définit la hauteur. Si une seule valeur est donnée, la seconde est définie sur 'auto'.</div>").appendTo($DivSaisieSize)
            $("<div style='font-size:70%;font-style:italic;opacity:0.3;'>(ex: 20% 30%): Définit la largeur et la hauteur de l'image d'arrière-plan en pourcentage de l'élément parent. La première valeur définit la largeur, la deuxième valeur définit la hauteur. Si une seule valeur est donnée, la seconde est définie sur 'auto'.</div>").appendTo($DivSaisieSize)

            $("<div style='font-size:120%;color:" + theme.backgroundcolorAccent + ";'>Position</div>").appendTo($DivArrierePlan)
            var backgroundPosition = option.elementArrierePlan.css("background-position")
            var dsPosition = [{ value: "left top", detail: "" },
            { value: "left center", detail: "" },
            { value: "left bottom", detail: "" },
            { value: "right top", detail: "" },
            { value: "right center", detail: "" },
            { value: "right bottom", detail: "" },
            { value: "center top", detail: "" },
            { value: "center center", detail: "" },
            { value: "center bottom", detail: "" },
            { value: "initial", detail: "" },
            { value: "inherit", detail: "" },
            { value: "personnalisé", detail: "" }]
            var selectedPosition = dsPosition.filter(function (o) { return o.value == backgroundPosition })[0]
            if (typeof selectedPosition == 'undefined') selectedPosition = dsPosition.filter(function (o) { return o.value == "personnalisé" })[0]
            $("<div style='padding-left:20px;'/>").appendTo($DivArrierePlan).dxCtrlRadioGroup({
                dataSource: dsPosition,
                focusStateEnabled: false,
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    $("<div>" + itemData.value + "</div>").appendTo(itemElement)
                    $("<div style='font-size:70%;opacity:0.6;line-height:1.2;'>" + itemData.detail + "</div>").appendTo(itemElement)
                },
                value: selectedPosition,
                layout: 'vertical',
                onValueChanged: function (e) {
                    if (e.value.value == "personnalisé") {
                        $DivSaisiePosition.slideDown(100)
                        backgroundPosition = dxTxtPosition.option("value")
                        option.elementArrierePlan.css("background-position", dxTxtPosition.option("value"))
                    } else {
                        $DivSaisiePosition.slideUp(100)
                        backgroundPosition = e.value.value
                        option.elementArrierePlan.css("background-position", backgroundPosition)
                    }
                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                }
            })
            var $DivSaisiePosition = $("<div style='padding-left:20px;" + ((selectedPosition.value == "personnalisé") ? "" : "display:none;") + "'/>").appendTo($DivArrierePlan)
            var dxTxtPosition = $("<div/>").appendTo($DivSaisiePosition).dxCtrlTextBox({
                value: ((typeof selectedPosition == 'undefined') ? backgroundPosition : ""),
                onValueChanged: function (e) {
                    backgroundPosition = e.value
                    option.elementArrierePlan.css("background-position", backgroundPosition)
                }
            }).dxCtrlTextBox("instance")
            $("<div style='font-size:70%;font-style:italic;opacity:0.3;'>(ex: 30px 25px): La première valeur est la position horizontale et la deuxième valeur est la position verticale.Le coin supérieur gauche est 0 0. Les unités peuvent être des pixels(0px 0px) ou toute autre unité CSS.Si vous ne spécifiez qu'une seule valeur, l'autre valeur sera de 50%.Vous pouvez mélanger % et positions.</div>").appendTo($DivSaisiePosition)
            $("<div style='font-size:70%;font-style:italic;opacity:0.3;'>(ex: 20% 30%): La première valeur est la position horizontale et la deuxième valeur est la position verticale.Le coin supérieur gauche est 0% 0%.Le coin inférieur droit indique 100% 100%.Si vous ne spécifiez qu'une seule valeur, l'autre valeur sera de 50%.La valeur par défaut est : 0% 0%.</div>").appendTo($DivSaisiePosition)

        } else {
            var $DivNew = $("<div style='padding:10px;text-align:center;'/>").appendTo($DivArrierePlan)
            var $A = $("<a href='javascript:void(0)'>Sélectionnez une image d'arrière plan</a>").appendTo($DivNew)
            $A.on("click", function () {
                $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                    bddCtrl: option.bddCtrl,
                    //imgInternet: true,
                    imgPexel: true,
                    accept: ".png,.jpg,.jpeg,.gif,.bmp",
                    multiple: false,
                    onValide: function (lstUrlFile) {
                        if (lstUrlFile.length > 0) {
                            var url = lstUrlFile[0];
                            $("<div/>").appendTo("body").dxCtrlPopupResizeImage({
                                bddCtrl: option.bddCtrl,
                                value: url,
                                onValidation: function (url) {
                                    option.elementArrierePlan.css("background-image", "url('" + url + "')")
                                    mRempliArrierePlan()
                                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                                }
                            })
                            //option.bddCtrl.mAjaxCall({
                            //    command: "migrein72dpiforemail",
                            //    urlimage: url
                            //}, function () {
                            //    option.elementArrierePlan.css("background-image", "url('" + url + "')")
                            //    mRempliArrierePlan()
                            //    if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
                            //})
                        }
                    }
                }).dxCtrlFileUploaderPopup("instance")
            })
        }
    }

    this.focus = function () { }

    this.element = function () { return container; }
    this.component = function () { }

    mConstruit();
}